import { email, z } from "zod";

export const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
  "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Andaman and Nicobar Islands", "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu",
  "Delhi", "Jammu and Kashmir", "Ladakh", "Lakshadweep", "Puducherry"
];


export const AddressSchemaIN = z.object({
  name: z
    .string()
    .min(3, "Full Name must have at least 3 characters")
    .max(60, "Full Name cannot exceed 60 characters"),

  address_line1: z
    .string()
    .min(5, "Address Line 1 must be at least 5 characters"),

  address_line2: z
    .string()
    .optional()
    .or(z.literal(""))
    .refine(val => val === "" || val.length >= 3, {
      message: "Address Line 2 must be at least 3 characters",
    }),

  postal_code: z
    .string()
    .regex(/^[1-9][0-9]{5}$/, "Enter a valid 6-digit PIN code"),

  city: z
    .string()
    .min(2, "City must be at least 2 characters"),

  state: z
    .string()
    .min(2, "Select a valid state"),

  phone: z
    .string()
    .regex(/^[6-9]\d{9}$/, "Enter a valid 10-digit phone number"),

  email: z
    .string()
    .email("Enter a valid email address")
    .optional()
    .or(z.literal("")),
  
  country: z.string().default("IN"),
});
